<script setup>
import { ref, defineExpose } from 'vue';

const loading = ref(true);

function hide() {
  loading.value = false;
}

function show() {
  loading.value = true;
}

const loadingApp = ref();

defineExpose({ hide, show, loadingApp });
</script>

<template >
  <div class="blockUI blockOverlay" v-show="loading" ref="loadingApp">
    <div class="spinner-border text-white" role="status"></div>
  </div>
</template>
